import { Icon } from '../brand';

/** A regular phone call, initiated only when the user taps the link. */
export function CallButton({ phone, label }: { phone?: string | null; label: string }) {
  if (!phone || !/^\+[1-9]\d{7,14}$/.test(phone)) return <span className="muted"><small>{label}: number not added</small></span>;
  return <a className="btn" href={`tel:${phone}`}><Icon name="phone" size={18} />{label}<small>{phone}</small></a>;
}
